import script from "./CustomFieldNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldNumberInput.vue?vue&type=script&setup=true&lang=js"

import "./CustomFieldNumberInput.vue?vue&type=style&index=0&id=f0d5ca04&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0d5ca04"]])

export default __exports__